import React, { useState, useCallback } from "react";
import HttpAction from "modules/utils/HttpAction";
const MainContext = React.createContext({
  state: { MainList: {} },
  actions: {
    getMain: () => {},
  },
});

const MainProvider = ({ children }) => {
  const [toplayoutList, setToplayoutList] = useState([]);
  const [notice, setNotice] = useState();
  const [popup, setPopup] = useState();
  const [statistic, setStatistic] = useState();
  
  const getToplayoutList = useCallback((isContainsContents) => {
    HttpAction({
      url:"api/member/main/toparea/list", 
      method: "get",
      params: {
        isContainsContents: isContainsContents,
      }
    }).then((res) => {
      if (res.code === 200) {
        setToplayoutList(res.data);
      } else {
      }
    });
  }, []);

  const getNotice = useCallback(() => {
    HttpAction({
      url:"/api/member/main/popup/notice", 
      method: "get",
    }).then((res) => {
      if (res.code === 200) {
        setNotice(res.data);
      } else {
      }
    });
  }, []);

  const getPopup = useCallback(() => {
    HttpAction({
      url:"/api/member/main/popup", 
      method: "get",
    }).then((res) => {
      if (res.code === 200) {
        setPopup(res.data);
      } else {
      }
    });
  }, []);

  const getFundStatistic = useCallback(() => {
    HttpAction({
      url: "/api/member/fund/statistic",
      method: "get",
    })
      .then((res) => {
        // Support both wrapped response { code: 200, data: { ... } }
        // and raw response { bizCount, fundCount, ... }
        if (res && res.code === 200 && res.data) {
          setStatistic(res.data);
        } else if (
          res &&
          (res.bizCount !== undefined ||
            res.fundCount !== undefined ||
            res.fundContractAmountUnit !== undefined ||
            res.baseDate !== undefined)
        ) {
          setStatistic(res);
        } else {
          console.warn("getFundStatistic: unexpected response", res);
        }
      })
      .catch((err) => {
        console.error("getFundStatistic error:", err);
      });
  }, []);

  const value = {
    state: { toplayoutList, notice, popup, statistic },
    actions: { getToplayoutList, getNotice, getPopup, getFundStatistic },
  };

  return (
    <MainContext.Provider value={value}>
      {children}
    </MainContext.Provider>
  );
};

const { Consumer: MainConsumer } = MainContext;

export { MainProvider, MainConsumer, MainContext };

export default MainContext;
